import { Controller } from "@hotwired/stimulus"

// Flash messages. A notice fades after 5 s; an alert (auto-value false)
// stays until the user closes it — an error nobody got to read is worse
// than one extra click.
export default class extends Controller {
  static values = { auto: { type: Boolean, default: true } }

  connect() {
    if (this.autoValue) this.timeout = setTimeout(() => { this.dismiss() }, 5000)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  dismiss() {
    this.element.remove()
  }
}
